import React from "react";
import { FaTrash } from "react-icons/fa";

export default function VisitsDeletePanel({
  dateDebut,
  dateFin,
  deleting,
  demoMode,
  onDateDebutChange,
  onDateFinChange,
  onDelete,
}) {
  return (
    <div className="overflow-hidden rounded-[28px] border border-rose-200 bg-white shadow-sm dark:border-rose-500/20 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-rose-500 to-orange-500" />

      <div className="p-4 sm:p-5 lg:p-6">
        <h2 className="text-xl font-bold text-slate-900 dark:text-white">
          Nettoyage des visites
        </h2>

        <p className="mt-1 text-sm leading-6 text-slate-600 dark:text-slate-300">
          Supprimez les visites d’une période précise pour alléger la base de
          données. Cette action est définitive.
        </p>

        <div className="mt-5 grid gap-3 lg:grid-cols-[1fr_1fr_auto]">
          <div>
            <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
              Date de début
            </label>

            <input
              type="date"
              value={dateDebut}
              onChange={(event) => onDateDebutChange(event.target.value)}
              className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-primary/40 dark:border-white/10 dark:bg-slate-950 dark:text-white"
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
              Date de fin
            </label>

            <input
              type="date"
              value={dateFin}
              onChange={(event) => onDateFinChange(event.target.value)}
              className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-primary/40 dark:border-white/10 dark:bg-slate-950 dark:text-white"
            />
          </div>

          <div className="flex items-end">
            <button
              type="button"
              onClick={onDelete}
              disabled={deleting || demoMode}
              className="inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-rose-600 px-5 py-2.5 text-sm font-bold text-white transition hover:bg-rose-700 disabled:cursor-not-allowed disabled:opacity-50 lg:w-auto"
            >
              <FaTrash />
              {deleting ? "Suppression..." : "Supprimer"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}